/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import * as color from '@constant/color';
import React from 'react';
import { getColorCode } from '@util/string';
import { css } from '@emotion/react';
import { useTypedSelector } from '@hook/common/useStore';
import TextBlock from '@component/common/block/text-block';
import { useAuthPage } from '@hook/auth/useAuth';
import { useNavigate } from 'react-router-dom';

interface IProps {
  name: string;
  design: {
    box?: {
      backgroundColor?: string;
    };
    position?: {
      // position
      top?: string; // e.g: 10px
      bottom?: string; // e.g: 10px
      left?: string; // e.g: 10px
      right?: string; // e.g: 10px
      transform?: string; // e.g: translate(-50%, -50%)
    };
    text?: {
      color?: string;
      size?: string; // e.g: 10px
    };
    avatarSize?: string; // e.g: 10px
  };
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Wrapper = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${(props) => {
    const { top, bottom, left, right } = props.design.position || {};
    return (
      (top || bottom || left || right) &&
      css`
        position: absolute;
        ${top && `top: ${top};`}
        ${bottom && `bottom: ${bottom};`}
        ${left && `left: ${left};`}
        ${right && `right: ${right};`}
      `
    );
  }}
  transform: ${(props) => props.design?.position?.transform || 'none'};
`;

const InitialAvatar = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: ${(props) => props.design?.box?.backgroundColor};
  width: ${(props) => props.design.avatarSize};
  height: ${(props) => props.design.avatarSize};
  color: ${(props) => props.design?.text?.color || color.WHITE_1};
  font-weight: bold;
  font-size: ${(props) => props.design?.text?.size};
  font-family: sans-serif;

  cursor: pointer;
`;

const Avatar: React.FC<IProps> = ({ name, design, onClick }) => {
  const { openAuthPage } = useAuthPage();
  const navigate = useNavigate();

  const handleSigninClick = () => openAuthPage('signin');
  const isAuthenticated = useTypedSelector((state) => state.rootReducer?.userReducer?.isAuthenticated) ?? false;

  return (
    <Wrapper design={design}>
      {isAuthenticated ? (
        <InitialAvatar
          onClick={onClick}
          design={{ ...design, box: { backgroundColor: design?.box?.backgroundColor || getColorCode(name) } }}>
          {name}
        </InitialAvatar>
      ) : (
        <TextBlock
          text={`로그인`}
          design={{
            text: { size: 'medium', color: color.BLACK_2, bold: false },
            box: { event: { cursor: 'pointer' } },
          }}
          click={{ handler: handleSigninClick }}
        />
      )}
    </Wrapper>
  );
};

export default Avatar;
